import PageNotFound from '@rhitics/vue/components/404.vue'
import { RouteConfig } from 'vue-router'

const coreRoutes: Array<RouteConfig> = [
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      authorize: false
    }
  }
]

export default coreRoutes
